<ol>    
    <mat-list-item [routerLink]="['/item/1']"><li>Aggregates</li></mat-list-item>
    <mat-list-item [routerLink]="['/item/2']"><li>One-To-Many</li></mat-list-item>
    <mat-list-item [routerLink]="['/item/3']"><li>Many-To-Many</li></mat-list-item>
    <mat-list-item [routerLink]="['/item/4']"><li>Hierarchical Queries</li></mat-list-item>
    <mat-list-item [routerLink]="['/item/5']"><li>Leaderboard</li></mat-list-item>
    <mat-list-item [routerLink]="['/item/6']"><li>Sparse Index</li></mat-list-item>
</ol>
<hr>
<mat-list-item [routerLink]="['/']"> About </mat-list-item>